import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgTick = (props) => {
    const { color } = props;
    return (React.createElement("path", { fill: color, d: "M9.58651 17.8339C9.19815 18.0921 8.67001 18.0493 8.32795 17.7056L4.29299 13.6507C3.90234 13.2581 3.90234 12.6216 4.29299 12.229C4.68364 11.8365 5.31702 11.8365 5.70767 12.229L9.04729 15.5852L18.2923 6.29444C18.683 5.90185 19.3164 5.90185 19.707 6.29444C20.0977 6.68702 20.0977 7.32352 19.707 7.71611L9.80424 17.6678C9.73787 17.7345 9.6645 17.7899 9.58651 17.8339Z" }));
};
export default factorySvgIcon(SvgTick);
//# sourceMappingURL=SvgTick.js.map